/**
 * @file 【组件】AI助手Logo入口
 * @author izzieyspu
 */

import React, { useCallback } from 'react';

import useAIAssistant from '../hooks/use-ai-assistant';
import { LOGO_BRAND_URL, AI_ASSISTANT_REPORT_EVENT_NAME } from '../constants';

interface LogoEntryProps {
  position: 'nav' | 'home-card';
}

export default (props: LogoEntryProps) => {
  const { position } = props;

  const { showAIAssistant, aiAssistantModal } = useAIAssistant();
  // 唤起AI助手
  const handleAIAssistantShow = useCallback(() => {
    showAIAssistant();
  }, [showAIAssistant]);

  return (
    <>
      {aiAssistantModal}
      <div
        className="tw-w-[86px] tw-h-[30px] tw-cursor-pointer tw-flex tw-items-center tw-justify-center"
        onClick={() => handleAIAssistantShow()}
        data-report={`${AI_ASSISTANT_REPORT_EVENT_NAME.ENTRY}__${position}`}
      >
        <img src={LOGO_BRAND_URL} height="20px" />
      </div>
    </>
  );
};
